var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    { staticClass: "dd-lang", attrs: { right: "" } },
    [
      _c("template", { slot: "button-content" }, [
        _c("div", {
          staticClass: "flag flag-selected",
          domProps: { innerHTML: _vm._s(_vm.selectedFlag) }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "selected-lang" }, [
          _vm._v(_vm._s(_vm.selectedLang))
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          staticClass: "language-drop-down",
          on: {
            click: function($event) {
              _vm.setLang("en")
            }
          }
        },
        [
          _c("div", {
            staticClass: "flag",
            domProps: { innerHTML: _vm._s(_vm.svg.en) }
          }),
          _vm._v(" English ")
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          staticClass: "language-drop-down",
          on: {
            click: function($event) {
              _vm.setLang("fr")
            }
          }
        },
        [
          _c("div", {
            staticClass: "flag",
            domProps: { innerHTML: _vm._s(_vm.svg.fr) }
          }),
          _vm._v(" Français ")
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          staticClass: "language-drop-down",
          on: {
            click: function($event) {
              _vm.setLang("es")
            }
          }
        },
        [
          _c("div", {
            staticClass: "flag",
            domProps: { innerHTML: _vm._s(_vm.svg.es) }
          }),
          _vm._v(" Español ")
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e5861ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5861ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Language.vue
// module id = 984
// module chunks = 2